import script from "./MenuMobileLocale.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMobileLocale.vue?vue&type=script&setup=true&lang=js"

import "./MenuMobileLocale.vue?vue&type=style&index=0&id=7184439e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7184439e"]])

export default __exports__